import ResourcesTextCard from "@/components/ui/resources-text-card";

export type MoreItemsCard = {
  title: string;
  titleHref: string;
  text: string;
  image: {
    src: string;
    alt: string;
  };
  leftInfo: string;
  rightInfo: string;
};

export interface MoreItemsProps {
  id?: string;
  title?: string;
  cards?: MoreItemsCard[];
}

const MoreItems: React.FC<MoreItemsProps> = ({
  id = "more-items",
  title,
  cards,
}) => {
  return (
    <section
      id={id}
      className="flex w-full bg-white"
    >
      <div className="grid w-full grid-cols-1 gap-4 px-4 py-6 md:gap-6 md:px-6 md:py-8 lg:mx-auto lg:max-w-lg lg:gap-8 lg:px-3 lg:py-0 lg:pb-10">
        <h2 className="font-montserrat text-heading-4 text-neutral-600 md:text-heading-3 lg:text-heading-2">
          {title}
        </h2>
        <div className="mx-auto grid max-w-lg auto-rows-auto grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 [&>*:nth-child(3)]:hidden lg:[&>*:nth-child(3)]:grid">
          {cards?.map((card, index) => (
            <ResourcesTextCard
              key={`${card.title}-${index}`}
              cardType="image"
              link="link-right"
              title={card.title}
              titleHref={card.titleHref}
              text={card.text}
              image={{
                src: card.image.src,
                alt: card.image.alt,
              }}
              leftInfo={card.leftInfo}
              rightInfo={card.rightInfo}
              styleOverrides={{
                container: "grid grid-rows-subgrid row-span-4",
                text: "line-clamp-3",
                image: "object-right",
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default MoreItems;
